module.exports = __webpack_public_path__ + "static/media/purchasesblue.7cce1819.svg";